import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Wrap = ({ size = 20, color = colors('neutral', 3) }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="8.25"
      y="8.25"
      width="7.5"
      height="7.5"
      rx="1.25"
      transform="rotate(-180 8.25 8.25)"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
    />
    <rect
      x="9"
      y="20"
      width="9"
      height="9"
      rx="2"
      transform="rotate(-180 9 20)"
      fill={color}
      stroke="none"
    />
    <path
      d="M12.2847 16.6152L14.1309 16.6152C15.2354 16.6152 16.1309 15.7198 16.1309 14.6152L16.1309 11.9998"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.1276 18.2288C12.5445 17.6368 11.6346 16.7128 11.6346 16.7128C11.6346 16.7128 12.5445 15.6699 13.1276 15.0016"
      fill="none"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      x="20.0005"
      y="9"
      width="9"
      height="9"
      rx="2"
      transform="rotate(-180 20.0005 9)"
      stroke="none"
      fill={color}
    />
  </svg>
);

export default Wrap;
